import React, { forwardRef } from 'react';
import { nanoid } from 'nanoid/non-secure';
import { VisuallyHidden } from '../../primitives/VisuallyHidden/VisuallyHidden.es.js';
import { Radio as Radio$1, Control, Label } from './styled.es.js';

var __defProp = Object.defineProperty;
var __getOwnPropSymbols = Object.getOwnPropertySymbols;
var __hasOwnProp = Object.prototype.hasOwnProperty;
var __propIsEnum = Object.prototype.propertyIsEnumerable;
var __defNormalProp = (obj, key, value) => key in obj ? __defProp(obj, key, { enumerable: true, configurable: true, writable: true, value }) : obj[key] = value;
var __spreadValues = (a, b) => {
  for (var prop in b || (b = {}))
    if (__hasOwnProp.call(b, prop))
      __defNormalProp(a, prop, b[prop]);
  if (__getOwnPropSymbols)
    for (var prop of __getOwnPropSymbols(b)) {
      if (__propIsEnum.call(b, prop))
        __defNormalProp(a, prop, b[prop]);
    }
  return a;
};
var __objRest = (source, exclude) => {
  var target = {};
  for (var prop in source)
    if (__hasOwnProp.call(source, prop) && exclude.indexOf(prop) < 0)
      target[prop] = source[prop];
  if (source != null && __getOwnPropSymbols)
    for (var prop of __getOwnPropSymbols(source)) {
      if (exclude.indexOf(prop) < 0 && __propIsEnum.call(source, prop))
        target[prop] = source[prop];
    }
  return target;
};
const Radio = forwardRef((_a, ref) => {
  var _b = _a, {
    id,
    name,
    value,
    label,
    isChecked,
    isDisabled,
    isInvalid,
    onChange,
    onBlur,
    onFocus,
    hideLabel,
    truncate,
    defaultChecked,
    size = "md"
  } = _b, props = __objRest(_b, [
    "id",
    "name",
    "value",
    "label",
    "isChecked",
    "isDisabled",
    "isInvalid",
    "onChange",
    "onBlur",
    "onFocus",
    "hideLabel",
    "truncate",
    "defaultChecked",
    "size"
  ]);
  id = id || `radio-${nanoid()}`;
  return /* @__PURE__ */ React.createElement(Radio$1, __spreadValues({
    isChecked,
    isDisabled,
    isInvalid,
    size
  }, props), /* @__PURE__ */ React.createElement(VisuallyHidden, {
    as: "input",
    type: "radio",
    id,
    name,
    value,
    onChange,
    onBlur,
    onFocus,
    checked: isChecked,
    disabled: isDisabled,
    defaultChecked,
    "aria-invalid": isInvalid,
    "aria-checked": isChecked,
    ref
  }), /* @__PURE__ */ React.createElement(Control, null), !hideLabel && /* @__PURE__ */ React.createElement(Label, {
    truncate
  }, label));
});
Radio.displayName = "Radio";

export { Radio };
//# sourceMappingURL=Radio.es.js.map
